import styled from "styled-components/macro"
import { DialogContent } from "@material-ui/core"
import { MultilineInput, PrimaryButton } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  display: flex;
  align-items: center; 
  gap: 12px;
`

export const ContactUsButton = styled(PrimaryButton)`
  margin-top: 30px;
`

export const Content = styled(DialogContent)`
  display: flex;
  min-width: 50vw;
  flex-direction: column;
  gap: 12px;
`

export const DemandInput = styled(MultilineInput)`
  .Field {
    width: 100%;
  }
`
